import React from "react";
import { useSite } from "../lib/SiteContext";
import { mediaUrl } from "../lib/api";

const DestinationsSection = () => {
  const { content } = useSite();
  const d = content?.destinations || {};
  const items = d.items || [];
  return (
    <section id="destinations" className="section-padding bg-background" data-testid="destinations-section">
      <div className="container-x">
        <div className="max-w-3xl mb-14 md:mb-20">
          <div className="overline mb-4">{d.overline}</div>
          <h2 className="font-serif text-4xl md:text-5xl lg:text-6xl tracking-tight text-primary text-balance">
            {d.title}
          </h2>
        </div>

        <div className="grid md:grid-cols-2 lg:grid-cols-12 gap-6">
          {items.map((it, i) => (
            <article
              key={i}
              className={`group relative overflow-hidden bg-primary text-white ${
                i === 0 ? "lg:col-span-7 aspect-[16/12] lg:aspect-auto lg:min-h-[520px]" : "lg:col-span-5 aspect-[4/3]"
              }`}
              data-testid={`destination-${i}`}
            >
              <img
                src={mediaUrl(it.image_url)}
                alt={it.name}
                className="absolute inset-0 w-full h-full object-cover transition-transform duration-700 group-hover:scale-105"
              />
              <div className="absolute inset-0 bg-gradient-to-t from-primary via-primary/40 to-transparent" />
              <div className="relative h-full flex flex-col justify-end p-8 md:p-10">
                <div className="overline mb-3 text-sand">{`0${i + 1}`}</div>
                <h3 className="font-serif text-3xl md:text-4xl lg:text-5xl mb-3 text-balance">{it.name}</h3>
                <p className="text-white/85 max-w-md leading-relaxed">{it.description}</p>
              </div>
            </article>
          ))}
        </div>
      </div>
    </section>
  );
};

export default DestinationsSection;
